import { Menu, Text, Portal } from '@chakra-ui/react';
import { MoreHorizontal } from 'react-feather';
import React, { useContext, useMemo } from 'react';
import { DataTableContext } from '..';

export const TableRowActions = (actionProps: { row: object }) => {
  const { tableProps: props } = useContext(DataTableContext);
  const { row } = actionProps;

  // using useMemo to avoid an additional calculation when the parent component re-renders
  const rowActions = useMemo(() => {
    if (!props.rowActions) {
      return null;
    }

    return typeof props.rowActions === 'function' ? props.rowActions(row) : props.rowActions;
  }, [props, row]);

  if (!rowActions || !rowActions.length) {
    return null;
  }

  return (
    <Text textAlign={'center'}>
      <Menu.Root closeOnSelect>
        <Menu.Trigger aria-label="Opens a menu to toggle which fields are rendered in the table">
          <MoreHorizontal
            cursor="pointer"
            size={20}
            color="var(--chakra-colors-icon-default)"
            style={{
              border: '1px solid var(--chakra-colors-border-transparent)',
              borderRadius: '50%',
              padding: '3px',
              outline: 'none !important',
            }}
          />
        </Menu.Trigger>
        <Portal>
          <Menu.Positioner>
            <Menu.Content title="Row Actions" borderRadius={'md'} borderColor={'border.transparent'} py={1} px={0}>
              {rowActions.map((action) => (
                <Menu.Item
                  cursor="pointer"
                  paddingX={2}
                  paddingY={2}
                  gap={1.5}
                  borderRadius={'0px'}
                  key={action.label}
                  value={action.label}
                  disabled={typeof action.isDisabled === 'function' ? action.isDisabled(row) : action.isDisabled}
                  onClick={(e) => {
                    const disabled =
                      typeof action.isDisabled === 'function' ? action.isDisabled(row) : action.isDisabled;
                    if (!disabled) {
                      action.callback(row);
                    } else {
                      e.stopPropagation();
                    }
                  }}
                  color={action.color}
                  css={{
                    '&[aria-disabled=true]': {
                      cursor: 'not-allowed',
                      opacity: 0.6,
                    },
                  }}
                >
                  {action.icon && action.icon}
                  <Text flex={1} fontSize={'xs'} fontWeight={'medium'}>
                    {action.label}
                  </Text>
                </Menu.Item>
              ))}
            </Menu.Content>
          </Menu.Positioner>
        </Portal>
      </Menu.Root>
    </Text>
  );
};
